'use client';

import Image from 'next/image';
import { Link } from '@/i18n/routing';
import { SidebarTrigger } from '../ui/sidebar';
import { Separator } from '../ui/separator';
import SearchInput from '../search-input';
import { LocaleSwitcher } from '../locale-switcher';
import { ThemeModeToggle } from './../themes/theme-mode-toggle';
import { SystemLogsDrawer } from '@/features/system-logs';
import { NotificationBell } from '@/features/notifications';
import { GlobalScannerButton } from '@/features/global-scanner';
// import { ActiveOcrJobsBadge } from '@/features/ocr';
import { UIConfig } from '../themes/ui-config';
import { HeaderUser } from '../header-user';
import { useDashboardLive } from '@/hooks/use-dashboard-live';
import { useEchoConnection } from '@/hooks/use-echo-connection';
import { usePermissions } from '@/hooks/use-permissions';
import { useFirstAccessibleRoute } from '@/hooks/use-nav';

export default function Header() {
  // Reverb carries the live updates; polling is the fallback only while the
  // socket is down.
  useDashboardLive();
  const { shouldFallback } = useEchoConnection();
  const { hasPermission } = usePermissions();
  const canViewLogo = hasPermission('branding.view_logo');
  const home = useFirstAccessibleRoute();

  return (
    <header className='bg-background sticky top-0 z-50 flex h-14 shrink-0 items-center justify-between border-b px-2 sm:px-4'>
      <div className='flex items-center gap-2 md:gap-3'>
        {canViewLogo && (
          <>
            <Link
              href={home}
              className='hidden w-6/12 items-center gap-2 md:flex'
            >
              <Image
                src='/logo/logo.png'
                alt='Safha Archive'
                width={200}
                height={100}
                priority
                style={{ width: 'auto', height: 'auto' }}
                className='block aspect-auto shrink-0 rounded-md dark:hidden'
              />
              <Image
                src='/logo/dark-logo.png'
                alt='Safha Archive'
                width={200}
                height={32}
                priority
                style={{ width: 'auto', height: 'auto' }}
                className='hidden aspect-auto shrink-0 rounded-md dark:block'
              />
            </Link>
            <Separator orientation='vertical' className='hidden h-5 md:block' />
          </>
        )}
        <SidebarTrigger className='-ms-1' />
      </div>

      <div className='flex items-center gap-1.5 sm:gap-2 md:gap-3'>
        <div className='hidden md:block'>
          <SearchInput />
        </div>
        <GlobalScannerButton />
        {/*<ActiveOcrJobsBadge />*/}
        <NotificationBell fallbackToPolling={shouldFallback} />
        <SystemLogsDrawer fallbackToPolling={shouldFallback} />
        {/* Keys mode is a translation-workflow tool: anyone who can read OR
            edit the localization catalog may read keys off the UI. */}
        <LocaleSwitcher
          enableKeysMode={
            hasPermission('localization.view') ||
            hasPermission('localization.edit')
          }
        />
        <div className='hidden md:flex md:items-center md:gap-2'>
          <ThemeModeToggle />
        </div>
        <UIConfig />
        <Separator orientation='vertical' className='hidden h-5 sm:block' />
        <HeaderUser />
      </div>
    </header>
  );
}
